import { useRef, useState } from "react";
import DropdownMenu from "./DropdownMenu";
import { ChevronDown } from "lucide-react";

export default function TaxPill({ value, onChange, disabled = false }) {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  return (
    <div ref={ref}>
      <button
        type="button"
        onClick={() => !disabled && setOpen(true)}
        disabled={disabled}
        className="
          w-full px-3 py-2 rounded-full text-sm
          border border-[var(--color-border)]
          bg-[var(--color-bg-muted)]
          flex justify-between items-center
          disabled:opacity-50 disabled:cursor-not-allowed
        "
      >
        <span>{value}%</span>
        <ChevronDown size={14} />
      </button>

      {open && !disabled && (
        <DropdownMenu
          anchorRect={ref.current?.getBoundingClientRect()}
          onClose={() => setOpen(false)}
        >
          {[0, 5, 12, 18, 28].map((rate) => (
            <button
              key={rate}
              onClick={() => {
                onChange(rate);
                setOpen(false);
              }}
              className="
                w-full px-3 py-2 text-left rounded-md
                hover:bg-[var(--color-bg-muted)]
              "
            >
              {rate}%
            </button>
          ))}
        </DropdownMenu>
      )}
    </div>
  );
}
